import React from 'react';

import FooterMenu from 'components/molecules/FooterMenu/FooterMenu';
import FooterCopyright from 'components/molecules/FooterCopyright/FooterCopyright';
import Box from 'components/atoms/Box/Box';

export default function Footer(props) {
  return (
    <Box
      style={{
        // position: 'absolute',
        // bottom: 0,
        // left: 0,
        width: '100%',
      }}
    >
      <FooterMenu />
      <FooterCopyright {...props} />
    </Box>
  );
}

Footer.propTypes = {};
